import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCustomContentDetailAPI, updateCustomContentActionsAPI } from "@modules/apis/custom-content";
import { parseEnumType, parseTypeToFieldType } from "@modules/content-schema";
import { updateCustomContentActions } from "@modules/propertyPanel";
import { setNotification } from "@modules/notification";
import { useTranslation } from "react-i18next";

const useExtendedCustomMetadata = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const stage = useSelector(({ stage }) => stage);
    const project = useSelector(({ project }) => project);

    const getCustomMetadata = async ({ contentId }) => {
        try {
            const response = await getCustomContentDetailAPI(stage.endpoint, project.id, contentId);
            const data = response.data;

            const fields = data?.fields?.map((v) => {
                const dataType = v.fieldType?.dataType;
                const newDataType = parseTypeToFieldType(dataType);
                const newField = { ...v, fieldType: { ...v.fieldType, dataType: { ...newDataType } } };
                const parsedField = parseEnumType(newField, "detail");

                return { ...parsedField };
            });
            return fields;
        } catch (error) {}
    };

    const updateCustomMetadata = useCallback(async ({ id, fields }) => {
        try {
            const action = `OVERWRITE_FIELD_VALUES`;
            await updateCustomContentActionsAPI(stage.endpoint, project.id, id, {
                action,
                data: { fields },
            });
        } catch (error) {
            dispatch(
                setNotification({
                    type: "error",
                    contents: t(
                        `common::msg::An error occured while changing Custom Metadata {type}`,
                        `An error occured while changing Custom Metadata {type}`,
                        {
                            type: fields?.[0]?.id,
                        },
                    ),
                }),
            );
        }
    }, []);

    return {
        getCustomMetadata,
        updateCustomMetadata,
    };
};

export default useExtendedCustomMetadata;
